import Modal from "react-bootstrap/Modal";
import FeedbackCarousel from "components/Feedback/FeedbackCarousel";
import * as React from 'react';
export default {
  Modal,
  FeedbackCarousel,
  React
};